import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, ArrowRight } from 'lucide-react';

export const CTASection = () => {
  return (
    <section className="cta-section">
      <div className="cta-pattern"></div>
      <div className="cta-container">
        <BookOpen className="cta-icon" size={48} />
        <h2 className="cta-title">
          Ознайомтесь з повним асортиментом продукції
        </h2>
        <p className="cta-subtitle">
          Завантажте наш каталог або переглянте онлайн
        </p>
        <Link to="/catalog" className="cta-button">
          Відкрити каталог
          <ArrowRight size={20} />
        </Link>
      </div>
    </section>
  );
};
